import { createRouter as createRouterLegacy, createWebHistory } from "vue-router";
import { setupLayouts } from "virtual:generated-layouts";
import { routes } from "vue-router/auto-routes";
import { useAuthStore } from "./stores/useAuthStore";
import { useSettingsStore } from "@/stores/useSettingsStore";

const redirects = [
  { path: "/admin", redirect: "/my/applications" },
  { path: "/admin/charity/:charityId", redirect: (to) => `/admin/charity/${to.params.charityId}/events` },
  { path: "/personal/charity/:charityId", redirect: (to) => `/personal/charity/${to.params.charityId}/dashboard` },
  { path: "/donationForm/charity/:charityId", redirect: (to) => `/donationForm/charity/${to.params.charityId}/forms` },
  { path: "/marketing/charity/:charityId", redirect: (to) => `/marketing/charity/${to.params.charityId}/dashboard` },
  { path: "/settings/charity/:charityId", redirect: (to) => `/settings/charity/${to.params.charityId}/profile` },
  { path: "/superadmin", redirect: "/superadmin/dashboard" },
  { path: "/fr/:pathMatch(.*)*", redirect: "/" },
  { path: "/en/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouterLegacy({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [...redirects, ...setupLayouts(routes)],
});

router.beforeEach(async (to) => {
  const authStore = useAuthStore();
  const settingsStore = useSettingsStore();

  if (isPublicPath(to)) {
    return true;
  }

  try {
    await authStore.authenticate({ currentPath: to });
  } catch (error) {
    if (error?.name === "NotFoundError") {
      return "/not-found";
    }
    return false;
  }

  if (authStore.me) {
    let roles = getRequiredRoles(to);
    for (let n in roles) {
      if (!hasRole(authStore.me, roles[n])) {
        console.log("NO ACCESS");
        return false;
      }
    }

    return true;
  } else {
    window.location.replace(`${settingsStore.settings.loginUrl}?redirectUrl=${window.location.href}`);
    return false;
  }
});

const isPublicPath = (to) => {
  for (let i = to.matched.length - 1; i >= 0; i--) {
    if (to.matched[i].meta.public !== undefined) {
      return to.matched[i].meta.public;
    }
  }
  return null;
};

const getRequiredRoles = (to) => {
  var roles = [];
  for (let i = to.matched.length - 1; i >= 0; i--) {
    if (to.matched[i].meta.roles !== undefined) {
      roles = roles.concat(to.matched[i].meta.roles);
    }
  }
  return roles;
};

const hasRole = (user, role) => {
  return user.userRoles.indexOf(role) !== -1 || user.userRoles.indexOf("ROLE_ALVARUM_PRODUCTS_ADMINISTRATOR") !== -1;
};

export function createRouterInstance() {
  return router;
}

export default router;
